import type { Dict } from "./lv.ts";

export const ua: Dict = {
  "app.title": "Stundio",
  "general.continue": "Продовжити",

  "nav.home": "Головна",
  "nav.week": "Тиждень",
  "nav.changes": "Зміни",
  "nav.subjects": "Предмети",
  "nav.transit": "Транспорт",
  "nav.settings": "Налаштування",
  "nav.group.schedule": "Розклад",
  "nav.group.personal": "Особисте",

  "onboarding.title": "Оберіть свій клас",
  "onboarding.subtitle": "Ваш розклад та його зміни — працює і офлайн.",

  "onboarding.persona.title": "Обери свою сторону",
  "onboarding.persona.subtitle": "Налаштуй розклад під свою роль",
  "onboarding.persona.student.title": "Учень",
  "onboarding.persona.student.desc": "Хочу бачити розклад своєї групи та заміни",
  "onboarding.persona.teacher.title": "Викладач",
  "onboarding.persona.teacher.desc": "Хочу бачити свої уроки, кабінети та заміни",

  "onboarding.teacher.title": "Обери викладача",
  "onboarding.teacher.subtitle": "Пошук за ім'ям або прізвищем",

  "teacher.search": "Пошук викладача…",
  "teacher.none": "Викладача не знайдено",
  "teacher.formClass": "Класний керівник",
  "teacher.cover": "Заміна",
  "teacher.coverFor": "Замінює: {name}",
  "teacher.view.own": "Мої уроки",
  "teacher.view.formClass": "Мій клас",

  "onboarding.language.title": "Оберіть мову",
  "onboarding.language.continue": "Продовжити",

  "onboarding.intro.skip": "Пропустити",
  "onboarding.intro.next": "Далі",
  "onboarding.intro.start": "Розпочати",
  "onboarding.intro.progress": "Крок вступу",
  "onboarding.intro.step1.title": "Ваш розклад в одному місці",
  "onboarding.intro.step1.body": "Зручний вигляд дня та тижня — як в EduPage, але швидше.",
  "onboarding.intro.step2.title": "Зміни відображаються миттєво",
  "onboarding.intro.step2.body":
    "Скасовані, перенесені та замінені уроки позначені — нічого не пропустите.",
  "onboarding.intro.step3.title": "Працює й без інтернету",
  "onboarding.intro.step3.body":
    "Розклад зберігається на вашому пристрої, тож він доступний навіть без мережі.",
  "onboarding.intro.step4.title": "Сповіщення про важливе",
  "onboarding.intro.step4.body":
    "Нагадування перед уроком і сигнал, якщо змінилися заміни — і більше нічого.",

  "class.search": "Пошук класів…",
  "class.none": "Класи не знайдено",
  "class.favorites": "Обрані",
  "class.all": "Усі класи",
  "class.loading": "Завантаження списку класів…",
  "class.favorite.add": "Додати до обраного",
  "class.favorite.remove": "Видалити з обраного",

  "subgroup.title": "У якій підгрупі {class} ти навчаєшся?",
  "subgroup.subtitle": "Цей клас поділено на підгрупи — обери свою, щоб бачити лише свої уроки.",
  "subgroup.option": "Підгрупа {label}",
  "subgroup.skip": "Пропустити — показувати обидві підгрупи",

  "day.today": "Сьогодні",
  "day.tomorrow": "Завтра",
  "day.yesterday": "Вчора",
  "day.jumpToday": "Перейти до сьогодні",
  "day.previousDay": "Попередній день",
  "day.nextDay": "Наступний день",
  "day.openCalendar": "Обрати дату",
  "day.previousMonth": "Попередній місяць",
  "day.nextMonth": "Наступний місяць",
  "day.pageHint": "Прогортайте ліворуч або праворуч чи використайте стрілки, щоб змінити день",
  "day.empty": "Немає уроків",
  "day.emptyHint": "Можливо, це канікули чи вихідний?",
  "day.noClass": "Спочатку оберіть клас",
  "day.changeClass": "Змінити клас",
  "day.noData": "Ще нічого не збережено",
  "day.noDataHint": "Підключіться до інтернету один раз, щоб завантажити розклад.",
  "week.longBreak": "Велика перерва · {min} хв",
  "week.noSchedule": "Розкладу на цей тиждень ще немає",
  "week.noScheduleHint":
    "Зазвичай він з’являється ближче до дати. Потягніть вниз, щоб перевірити оновлення.",
  "day.stale": "Розклад на цей тиждень ще не опубліковано — показуємо попередній.",
  "day.offline": "Немає підключення до інтернету — показуємо збережений розклад.",
  "day.buildingOther": "Інший корпус: {building}",
  "day.buildingMixed": "Кілька корпусів: {buildings}",
  "home.schedule": "Розклад на день",
  "home.notifyBlocked":
    "Сповіщення вимкнені — нагадування й оповіщення про зміни не надходитимуть.",
  "home.notifyBlockedWeb":
    "Сповіщення заблоковані в браузері — увімкніть їх у налаштуваннях сайту, щоб отримувати оповіщення.",
  "day.notes": "Оголошення",
  "day.allNotes": "Усі оголошення школи ({count})",
  "day.onlyMyGroup": "Лише для моєї групи",
  "day.free": "Вільний урок",
  "day.finished": "Уроки закінчилися",
  "day.now": "Зараз",
  "day.glance.left": "Залишилося {duration}",
  "day.glance.in": "Через {duration}",
  "day.glance.following": "Далі",
  "day.glance.walk": "Йти до {building}",
  "day.glance.walkFrom": "Перехід із {from} до {building}",
  "day.summary.lessons": "Уроків: {count}",
  "day.summary.free": "Вікна: {duration}",
  "day.summary.lessonsTooltip": "Усього уроків цього дня",
  "day.summary.freeTooltip": "Загальний вільний час між уроками",
  "day.tomorrow.eyebrow": "Наступний навчальний день · {weekday}",
  "day.tomorrow.starts": "Початок о {time}",
  "day.tomorrow.changes": "Змін: {count}",
  "day.tomorrow.open": "Відкрити {weekday}: початок о {time}",
  "day.glance.open": "Відкрити {title}, {countdown}",
  "day.feedbackPrompt.title": "Є ідея?",
  "day.feedbackPrompt.body": "Розкажи, що додати чи виправити в Stundio.",
  "day.feedbackPrompt.action": "Запропонувати",
  "day.feedbackPrompt.dismiss": "Закрити",
  "day.androidBanner.title": "Stundio для Android",
  "day.androidBanner.body":
    "Завантажте застосунок для віджетів на головному екрані, фонової синхронізації та офлайн-розкладу.",
  "day.androidBanner.action": "Завантажити APK",
  "day.androidBanner.dismiss": "Закрити",
  "day.updatePrompt.title": "Доступне оновлення",
  "day.updatePrompt.body": "Доступна новіша версія Stundio ({version}).",
  "day.updatePrompt.action": "Оновити",
  "day.updatePrompt.dismiss": "Пізніше",
  "day.updatePrompt.handoff":
    "Завантаження завершено. Підтвердьте встановлення у вікні Android або натисніть «Оновити», щоб повторити.",
  "day.changesBadge": "{n} змін",

  "changes.title": "Зміни",
  "changes.filter.myClass": "Моя група",
  "changes.filter.myChanges": "Мої зміни",
  "changes.filter.all": "Вся школа",
  "changes.absentTeachers": "Сьогодні відсутні",
  "changes.emptyForClass": "Змін немає",
  "changes.emptyForClassHint": "У вашої групи уроки йдуть за звичайним розкладом",
  "changes.emptyAll": "Немає зареєстрованих змін",
  "changes.emptyAllHint": "Технікум не публікував змін на цей день",
  "changes.otherGroupsHaveChanges": "Сьогодні є {n} змін для інших груп",
  "changes.viewOtherGroups": "Дивитися всі зміни",
  "changes.searchPlaceholder": "Пошук за групою, предметом або викладачем…",
  "changes.searchNoResults": "Нічого не знайдено",
  "changes.count": "{n} змін",
  "changes.badge": "{n} змін",
  "changes.notesFromSchool": "Оголошення технікуму",
  "changes.rvtWebsite": "Сайт RVT",

  "week.previousWeek": "Попередній тиждень",
  "week.nextWeek": "Наступний тиждень",
  "week.buildingDays": "{building}: {days}",
  "week.overview.title": "Огляд",
  "week.overview.lessons": "{n} уроків",
  "week.overview.lessonsUp": "+{n} порівняно з минулим тижнем",
  "week.overview.lessonsDown": "{n} порівняно з минулим тижнем",
  "week.overview.lessonsSame": "Так само, як минулого тижня",
  "week.overview.changes": "{n} змін",
  "week.overview.changesNone": "Без змін",
  "week.overview.busiestLabel": "Найзавантаженіший день",
  "week.overview.lightestLabel": "Найлегший день",

  "share.week": "Поділитися тижнем",
  "share.working": "Створюємо зображення…",
  "share.error": "Не вдалося створити зображення",
  "share.title": "Розклад {name}",
  "share.message":
    "{name} розклад {period} \nХочете зробити користування EduPage зручнішим? Завітайте на: https://bit.ly/stundio",
  "share.image.classTeacher": "Класний керівник",
  "share.image.appLabel": "Зручніший EduPage на телефоні",
  "share.language.title": "Якою мовою поділитися?",
  "share.language.sync": "Синхронізувати зображення з мовою застосунку",
  "share.language.continue": "Продовжити",

  "lesson.teacher": "Учитель",
  "lesson.room": "Кабінет",
  "lesson.period": "Урок",
  "lesson.group": "Група",
  "lesson.building": "Корпус",
  "lesson.was": "Було",
  "lesson.fromSchool": "Від школи",
  "lesson.note": "Оголошення",
  "lesson.close": "Закрити",

  "status.cancelled": "Скасовано",
  "status.moved": "Перенесено",
  "status.substituted": "Заміна",
  "status.room_change": "Зміна кабінету",
  "status.added": "Додатковий урок",

  "sync.syncing": "Оновлення…",
  "sync.offline": "Офлайн",
  "sync.error": "Помилка оновлення",
  "sync.never": "Ніколи не оновлювалося",
  "sync.updated": "Оновлено {time}",
  "sync.refresh": "Оновити",
  "sync.pull": "Потягніть, щоб оновити",
  "sync.release": "Відпустіть, щоб оновити",
  "sync.toast": "Оновлено",

  "time.inMinutes": "через {n} хв",
  "time.minutesLeft": "залишилося {n} хв",
  "time.startsNow": "починається зараз",

  "subjects.title": "Предмети",
  "transit.title": "Транспорт",
  "transit.plan.title": "Мій маршрут",
  "transit.plan.description":
    "Вкажіть початкову точку та пункт призначення. Маршрут відкриється в Google Maps.",
  "transit.plan.home": "Звідки",
  "transit.plan.homePlaceholder": "Домашня адреса",
  "transit.plan.useLocation": "Використати моє місцезнаходження",
  "transit.plan.savedHome": "Початкова точка з налаштувань: {address}",
  "transit.plan.homeMissing":
    "Додайте домашню адресу в налаштуваннях або використайте поточне місцезнаходження.",
  "transit.plan.destination": "Куди",
  "transit.plan.destinationPlaceholder": "Адреса або назва місця",
  "transit.plan.transitDuration": "Транспорт і пересадки (хвилини)",
  "transit.plan.walkDuration": "Пішки до зупинки (хвилини)",
  "transit.plan.nextLesson": "Наступний урок: {subject}, о {time}",
  "transit.plan.class": "урок",
  "transit.plan.leaveAt": "Вийти приблизно о {time}",
  "transit.plan.leaveHint": "Враховує вказаний час пішки до зупинки та в транспорті.",
  "transit.plan.noLesson": "Сьогодні в обраної групи більше немає занять.",
  "transit.plan.findRoute": "Знайти маршрут громадським транспортом",
  "transit.plan.destinationNeeded": "Вкажіть пункт призначення, щоб знайти маршрут.",
  "transit.plan.mapsNote": "Google Maps покаже доступні маршрути та час відправлення.",
  "transit.plan.mapsKeyNeeded":
    "Для вбудованої карти Google Maps потрібне налаштування застосунку.",
  "transit.plan.mapTitle": "Маршрут громадського транспорту в Google Maps",
  "transit.plan.goToSchool": "До школи",
  "transit.plan.goHome": "Додому",
  "transit.plan.schoolDay": "Перший урок о {start} · {building} · останній урок до {end}",
  "transit.plan.main": "головному корпусі",
  "transit.plan.tic": "Центрі технологій та інновацій",
  "transit.plan.startsAtSeven": "Маршрути до школи з’являться з 7:00.",
  "transit.plan.fromTo": "Маршрут",
  "transit.plan.currentLocation": "Ваше місцезнаходження",
  "transit.plan.homeAddress": "Дім ({address})",
  "transit.plan.homeward": "додому",
  "transit.plan.noHome": "домашню адресу не вказано",
  "transit.plan.refreshLocation": "Оновити GPS",
  "transit.plan.refreshRoutes": "Оновити маршрути",
  "transit.plan.lessonsAtTic": "Заняття відбуваються в Центрі технологій та інновацій.",
  "transit.plan.alreadyAtSchool": "Ви вже біля школи.",
  "transit.plan.loadingRoutes": "Шукаємо маршрути громадського транспорту…",
  "transit.plan.routesKeyNeeded":
    "Щоб показати маршрути, додайте до застосунку ключ Google Routes API.",
  "transit.plan.routesUnavailable": "Не вдалося завантажити маршрути. Спробуйте ще раз пізніше.",
  "transit.plan.noRoutes": "Для цього маршруту не знайдено громадського транспорту.",
  "transit.plan.option": "Варіант {number}",
  "transit.plan.leaveAround": "Вийти з дому близько {time}",
  "transit.plan.walk": "Пішки",
  "transit.plan.locationUnavailable": "На цьому пристрої місцезнаходження недоступне.",
  "transit.plan.locationLoading": "Визначаємо місцезнаходження…",
  "transit.plan.locationReady": "Для маршруту використовується ваше місцезнаходження.",
  "transit.plan.locationDenied":
    "Не вдалося визначити місцезнаходження. Перевірте дозвіл браузера.",
  "transit.live.title": "Транспорт Риги наживо",
  "transit.live.description":
    "Переглядайте на мапі, де перебуває транспорт, і час прибуття на зупинки наживо.",
  "transit.live.show": "Показати мапу наживо",
  "transit.live.source": "Мапа Rīgas satiksme",
  "transit.live.openFull": "Відкрити на весь екран",
  "transit.live.frameTitle": "Мапа транспорту Rīgas satiksme наживо",
  "transit.destinations.title": "Збережені адреси",
  "transit.destinations.description": "Збережені адреси є початком маршруту до RVT.",
  "transit.destinations.currentLocation": "З поточного місцезнаходження",
  "transit.destinations.rvtAddress": "Пункт призначення: RVT · {address}",
  "transit.destinations.openGoogleMaps": "Відкрити Google Maps",
  "transit.destinations.nameLabel": "Назва місця",
  "transit.destinations.namePlaceholder": "Школа, робота, друзі…",
  "transit.destinations.addressLabel": "Адреса",
  "transit.destinations.addressPlaceholder": "Вулиця, будинок, місто",
  "transit.destinations.add": "Додати адресу",
  "transit.destinations.remove": "Видалити {label}",
  "transit.destinations.locationUnavailable": "На цьому пристрої місцезнаходження недоступне.",
  "transit.destinations.gettingLocation": "Визначаємо місцезнаходження…",
  "transit.destinations.locationDenied": "Дозвольте доступ до місцезнаходження, щоб прокласти маршрут звідти.",
  "transit.destinations.plannerTitle": "Планувальник маршрутів Rīgas satiksme",
  "transit.destinations.plannerDescription": "Планувальник відкрито для адреси: {destination}.",
  "transit.destinations.backToMap": "Назад до мапи",
  "transit.live.locationNote":
    "Щоб показати своє місцезнаходження, скористайтеся кнопкою геолокації на мапі та дозвольте доступ, якщо браузер запитає.",
  "subjects.perWeek": "{n}× на тиждень",
  "subjects.teachers": "Учителі",
  "subjects.empty": "Немає предметів",
  "subjects.emptyHint": "Предмети з'являться після завантаження розкладу.",
  "subjects.note.placeholder": "Нотатка для цього предмета…",
  "subjects.note.save": "Зберегти",
  "subjects.note.badge": "Є нотатка",

  "settings.title": "Налаштування",
  "settings.commute": "Дорога до школи",
  "settings.commute.home": "Домашня адреса",
  "settings.commute.homePlaceholder": "Введіть адресу або назву місця",
  "settings.commute.homeHint":
    "Зберігається лише на цьому пристрої та використовується для планування маршруту.",
  "settings.persona.student": "Учень",
  "settings.persona.teacher": "Викладач",
  "settings.identity.sheetTitle": "Вибір ролі",
  "settings.identity.confirm": "Підтвердити",
  "settings.class": "Моя група",
  "settings.change": "Змінити",
  "settings.building": "Корпус",
  "settings.buildingAuto": "Автоматично",
  "settings.subgroup": "Підгрупа",
  "settings.subgroupAll": "Обидві",
  "settings.customization": "Персоналізація",
  "settings.theme": "Зовнішній вигляд",
  "settings.language": "Мова",
  "settings.share": "Поширення",
  "settings.shareLanguage": "Мова зображення",
  "settings.mergeLessons": "Об'єднувати однакові уроки",
  "settings.mergeLessonsHint":
    "Показує предмет, який іде кілька уроків поспіль у вигляді тижня, як один довгий блок.",
  "settings.movedOnTarget": "Показувати перенесені уроки в новий день",
  "settings.movedOnTargetHint":
    "Урок, перенесений на інший день, показується в цей день, а не в попередній.",
  "view.options": "Параметри вигляду",
  "settings.showTime": "Показувати час",
  "settings.showTimeHint":
    "Відображає час початку та закінчення кожного уроку поруч із його номером.",
  "settings.showSubjectsTab": "Вкладка «Предмети»",
  "settings.showSubjectsTabHint":
    "Показує вкладку предметів у нижньому меню, поруч із налаштуваннями.",
  "settings.notifications": "Сповіщення",
  "settings.notifyLessonReminder": "Нагадування про урок",
  "settings.notifyLessonReminderHint": "Сповіщати перед початком наступного уроку.",
  "settings.notifyLessonReminderOff": "Вимкнено",
  "settings.notifySubstitutionChanges": "Зміни в розкладі",
  "settings.notifySubstitutionChangesHint":
    "Сповіщати, коли змінюються уроки на сьогодні або завтра.",
  "settings.notifyNewTimetable": "Новий розклад",
  "settings.notifyNewTimetableHint": "Сповіщати, коли школа публікує розклад на новий тиждень.",
  "settings.notifyAppUpdates": "Оновлення застосунку",
  "settings.notifyAppUpdatesHint": "Сповіщати про вихід нової версії застосунку.",
  "settings.notifyExactAlarmDenied":
    "Система забороняє точні будильники — нагадування можуть запізнюватися. Дозвольте «Будильники та нагадування».",
  "settings.notifyPermissionDenied": "Сповіщення заблоковані в налаштуваннях системи.",
  "settings.notifyOpenSettings": "Відкрити налаштування",
  "settings.notificationsWebNotice":
    "Офлайн-нагадування та сповіщення доступні в додатку для Android. У веб-версії зміни оновлюються при відкритті.",
  "settings.notificationsIosPwaRequired":
    "Щоб отримувати сповіщення на iPhone, спочатку додайте Stundio на головний екран.",
  "settings.notificationsLessonRemindersNativeNotice":
    "Нагадування перед кожним уроком доступні в застосунку Android. Сповіщення про зміни розкладу працюють через Web Push.",
  "notification.lessonReminder.title": "{subject} через {minutes} хв",
  "notification.changed.title": "Розклад змінився",
  "notification.changed.body": "У розкладі на сьогодні є зміни.",
  "notification.cover.title": "Нова заміна",
  "notification.cover.body": "Вам призначено заміну",
  "notification.newTimetable.title": "Новий розклад",
  "notification.newTimetable.body": "Опубліковано новий розклад з {date}.",
  "notification.update.title": "Доступне оновлення",
  "notification.update.body": "Stundio {version} готовий до завантаження.",
  "widget.now": "Зараз",
  "widget.next": "Далі",
  "widget.done": "Уроків сьогодні більше немає",
  "widget.noClass": "Обери клас",
  "widget.noData": "Відкрий Stundio, щоб оновити",
  "widget.minutesLeft": "ще {minutes} хв",
  "widget.minutesUntil": "через {minutes} хв",
  "settings.data": "Дані",
  "settings.analytics": "Анонімна аналітика використання",
  "settings.analyticsHint":
    "Допомагає зрозуміти, які функції використовуються. Без файлів cookie та персональних даних.",
  "settings.about": "Про застосунок",
  "settings.aboutText":
    "Неофіційний застосунок. Дані взяті з публічного розкладу pikcrvt.edupage.org і належать школі.",
  "settings.currentVersion": "Поточна версія: {version}",
  "settings.checkForUpdatesAction": "Перевірити",
  "settings.checkingForUpdates": "Перевірка…",
  "settings.upToDate": "У вас остання версія",
  "settings.updateAvailable": "Доступна новіша версія ({version})",
  "settings.updateAction": "Завантажити",
  "settings.updateDownloading": "Завантаження… {percent}%",
  "settings.updateError": "Помилка оновлення: {message}",
  "settings.updateFailed": "Помилка оновлення",
  "whatsNew.title": "Що нового",
  "whatsNew.eyebrow": "Версія {version}",
  "whatsNew.done": "Зрозуміло",
  "whatsNew.history": "Попередні версії",
  "whatsNew.empty": "Списку змін поки немає.",
  "settings.whatsNew": "Що нового",
  "settings.whatsNewHint": "Зміни в цій та попередніх версіях",
  "settings.dangerZone": "Небезпечна зона",
  "settings.resetData": "Скинути всі дані",
  "settings.resetDataHint": "Видаляє нотатки та скидає налаштування.",
  "settings.resetDataConfirmTitle": "Скинути всі дані?",
  "settings.resetDataConfirmBody":
    "Усі нотатки будуть видалені, а налаштування скинуті до початкових. Додаток повернеться до початкового налаштування.",
  "settings.resetDataConfirmButton": "Скинути всі дані",
  "settings.resetDataCancelButton": "Скасувати",
  "feedback.sheet.title": "Запропонувати функцію",
  "feedback.sheet.messageLabel": "Твоя ідея чи пропозиція",
  "feedback.sheet.messagePlaceholder": "Що Stundio варто додати чи покращити?",
  "feedback.sheet.emailLabel": "Твій email (необов'язково)",
  "feedback.sheet.emailPlaceholder": "Якщо бажаєш отримати відповідь",
  "feedback.sheet.submit": "Надіслати пропозицію",
  "feedback.sheet.submitting": "Надсилання…",
  "feedback.sheet.successTitle": "Дякуємо за ідею!",
  "feedback.sheet.successBody": "Твою пропозицію надіслано. Дякуємо за допомогу!",
  "feedback.sheet.bugTitle": "Повідомити про помилку",
  "feedback.sheet.bugMessageLabel": "Що сталося?",
  "feedback.sheet.bugMessagePlaceholder": "Опишіть, що пішло не так і чого ви очікували…",
  "feedback.sheet.bugSubmit": "Надіслати звіт",
  "feedback.sheet.bugSubmitting": "Надсилання…",
  "feedback.sheet.bugSuccessTitle": "Звіт надіслано!",
  "feedback.sheet.bugSuccessBody": "Дякуємо за повідомлення! Ми обов'язково розберемося.",
  "feedback.sheet.close": "Закрити",
  "feedback.sheet.error": "Не вдалося надіслати. Перевір підключення до інтернету.",
  "feedback.sheet.attachScreenshot": "Прикріпити скріншот",
  "feedback.sheet.removeScreenshot": "Видалити скріншот",
  "feedback.sheet.screenshotTooLarge": "Зображення занадто велике (макс. 5 МБ)",
  "settings.madeBy": "Зроблено з ❤︎ Дмитром Поліжаєм",

  "theme.system": "Системна",
  "theme.light": "Світла",
  "theme.dark": "Темна",

  "customization.title": "Персоналізація",
  "customization.theme": "Зовнішній вигляд",
  "customization.accent": "Акцентний колір",
  "customization.accent.hint": "Колір для виділень — сьогоднішньої дати, вибраної опції.",
  "customization.accent.reset": "За замовчуванням",
  "customization.lessonStyle": "Картки уроків",
  "customization.lessonStyle.hint": "Як колір предмета показано в списку дня.",
  "customization.lessonStyle.outline": "Контур",
  "customization.lessonStyle.filled": "Заливка",
  "customization.radius": "Заокруглення кутів",
  "customization.radius.compact": "Компактне",
  "customization.radius.balanced": "Середнє",
  "customization.radius.standard": "Стандартне",
  "customization.radius.rounder": "Більш округле",
  "customization.elevation": "Глибина карток",
  "customization.elevation.soft": "М'яка",
  "customization.elevation.bold": "Виразна",
  "customization.reduceMotion": "Менше анімації",
  "customization.reduceMotion.hint": "Вимикає переходи й анімації в застосунку.",
  "customization.subjectColors": "Кольори предметів",
  "customization.subjectColors.enabled": "Кольорове кодування предметів",
  "customization.subjectColors.enabled.hint":
    "Вимкнено — кожен предмет показаний одним нейтральним кольором у списку дня й на тижні.",
  "customization.subjectColors.hint":
    "Торкнися кольору, щоб призначити його; торкнися «Авто», щоб повернути типовий колір.",
  "customization.subjectColors.reset": "Авто",
  "customization.subjectColors.custom": "Власний колір",
  "customization.subjectColors.lightness": "Яскравість",
  "customization.subjectColors.empty": "Вибери клас, щоб налаштувати кольори предметів.",
  "customization.subjectColors.hint.teacher":
    "Це предмети, які ти викладаєш. Торкнися кольору, щоб призначити його; торкнися «Авто», щоб повернути типовий колір.",
  "customization.subjectColors.empty.teacher":
    "Вибери себе як викладача, щоб налаштувати кольори своїх предметів.",
  "customization.preview.subject": "Приклад предмета",
  "customization.reset": "Скинути налаштування",

  "iphoneInstall.title": "Додайте Stundio на початковий екран",
  "iphoneInstall.subtitle":
    "Використовуйте Stundio як повноцінний застосунок на iPhone — на весь екран, без зайвих панелей і без інтернету.",
  "iphoneInstall.step1":
    "Натисніть кнопку «На початковий екран» нижче або кнопку Поділитися в Safari",
  "iphoneInstall.step2": "У меню виберіть «На початковий екран»",
  "iphoneInstall.action": "Додати на початковий екран",
  "teacherAnnouncement.title": "Stundio для вчителів",
  "teacherAnnouncement.headline": "Тепер доступно і вчителям",
  "teacherAnnouncement.subtitle":
    "Вчителі тепер можуть використовувати Stundio для перегляду свого розкладу та замін.",
  "teacherAnnouncement.step1.title": "Перейдіть до налаштувань",
  "teacherAnnouncement.step1.desc": "Відкрийте вкладку налаштувань",
  "teacherAnnouncement.step2.title": "Змініть профіль",
  "teacherAnnouncement.step2.desc": "Виберіть профіль вчителя",
  "teacherAnnouncement.step3.title": "Виберіть своє ім'я",
  "teacherAnnouncement.step3.desc": "Знайдіть себе у списку, щоб отримати розклад",
  "teacherAnnouncement.tryIt": "Спробувати",
  "teacherAnnouncement.done": "Зрозуміло",
  "settings.teacherShare": "Функції для вчителів",
  "settings.teacherShareHint": "Показати сповіщення про функції для вчителів",
  "iphoneInstall.dismiss": "Продовжити в браузері",
  "settings.iphoneInstall": "Додати на початковий екран",
  "settings.iphoneInstallHint": "Встановити Stundio як застосунок на iPhone",

  "settings.group.schedule": "Розклад",
  "settings.group.appearance": "Вигляд і мова",
  "settings.identityHint": "Чий розклад показувати на головній, у тижні та у віджеті.",
  "settings.subgroupHint": "Приховує уроки іншої підгрупи з дня та тижня.",
  "settings.buildingHint": "Показувати розклад лише одного корпусу або обох одразу.",
  "settings.themeHint": "Світле, темне або як у системі телефона.",
  "settings.languageHint": "Мова інтерфейсу. Предмети й заміни лишаються латиською, як в EduPage.",
  "settings.customizationHint": "Кольори предметів, акцент, стиль і заокруглення карток.",
  "settings.shareLanguageHint":
    "Якою мовою підписані картинка тижня та повідомлення, якими ви ділитеся.",
  "settings.shareLangFollowApp": "Як у застосунку",
  "settings.sync": "Синхронізація",
  "settings.syncHint":
    "Розклад зберігається на телефоні й працює без мережі. Натисніть, щоб оновити.",
  "settings.updates": "Оновлення",
  "settings.updatesHint": "Перевіряє та встановлює нову версію прямо із застосунку.",
  "settings.version": "Версія",
  "settings.versionHint": "Версія застосунку на цьому пристрої.",
  "settings.reportIssueRow": "Повідомити про помилку",
  "settings.reportIssueHint": "Опишіть проблему — автор отримає її разом із версією застосунку.",
  "settings.suggestFeatureRow": "Запропонувати ідею",
  "settings.suggestFeatureHint": "Що додати або змінити в застосунку.",
  "settings.notifyPermissionDeniedTitle": "Сповіщення заборонені",
  "settings.notifyExactAlarmTitle": "Нагадування можуть запізнюватися",
  "settings.notificationsWebTitle": "Сповіщення в застосунку Android",
  "settings.minutes": "{minutes} хв",
  "settings.reminderOption": "За {minutes} хв до уроку",

  "error.title": "Щось пішло не так",
  "error.hint": "Не вдалося завантажити цей екран.",
  "error.retry": "Спробувати знову",
};
